import Image from 'next/legacy/image';
import React from 'react';

type ToolTipProps = {
  icon?: string;
  title?: string;
  children?: any;
  contentStyle?: string;
  containerStyle?: string;
};

const ToolTip: React.FC<ToolTipProps> = ({
  icon = '/assets/icons/info-blue.svg',
  title = '',
  children,
  contentStyle,
  containerStyle = 'absolute mt-1 ml-4 hidden w-[345px] flex-col group-hover:flex',
}) => {
  return (
    <div className="group">
      <div className="flex items-center">
        <Image
          src={icon}
          width="20"
          height="20"
          alt={title}
          className="cursor-pointer"
        />
      </div>
      {title}
      <div className={containerStyle}>
        <span className={`whitespace-no-wrap z-10 p-4 ${contentStyle}`}>
          {children}
        </span>
      </div>
    </div>
  );
};

export default ToolTip;
